var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSunshine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Flat",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m232 144a40 40 0 0 1 -57.5 35.97 63.99 63.99 0 0 1 -93 0 39.991 39.991 0 1 1 -9.4-75.15 64.015 64.015 0 0 1 111.8 0 40.038 40.038 0 0 1 48.1 39.18z",
    fill: "#a3d4f7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m203.955 381.648c-7.641-3.166-8.66-21.816-15.257-26.282s-23.4 2.355-28.865-3.2.4-23.487-3.844-29.919-22.7-7.105-25.637-14.2 9.63-20.619 8.085-28.171-18.374-16.083-18.437-23.876 16.64-14.849 18.148-22.672-10.961-21.732-7.8-29.373 21.816-8.66 26.282-15.257-2.355-23.4 3.2-28.865 23.487.4 29.919-3.844 7.1-22.7 14.2-25.637 20.619 9.63 28.171 8.085 16.087-18.374 23.88-18.437 14.849 16.64 22.672 18.148 21.732-10.961 29.373-7.8 8.66 21.816 15.257 26.282 23.4-2.355 28.865 3.2-.4 23.487 3.844 29.919 22.7 7.1 25.637 14.2-9.63 20.619-8.085 28.171 18.374 16.087 18.437 23.88-16.64 14.849-18.148 22.672 10.961 21.732 7.8 29.373-21.816 8.66-26.282 15.257 2.355 23.4-3.2 28.865-23.487-.4-29.919 3.844-7.105 22.7-14.2 25.637-20.619-9.63-28.171-8.085-16.087 18.374-23.88 18.437-14.849-16.64-22.672-18.148-21.728 10.961-29.373 7.796z",
    fill: "#ffb632"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#ffd33a",
    r: 88
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m447.986 352.561c0-.187.014-.373.014-.561a40.01 40.01 0 0 0 -57.506-35.972 48.014 48.014 0 0 0 -92.988 0 40.01 40.01 0 0 0 -57.506 35.972c0 .188.012.374.014.561-22.706 3.171-40.014 19.616-40.014 39.439 0 22.091 21.49 40 48 40 18.326 0 34.249-8.561 42.336-21.144a63.979 63.979 0 0 0 107.328 0c8.087 12.583 24.01 21.144 42.336 21.144 26.51 0 48-17.909 48-40 0-19.823-17.307-36.268-40.014-39.439z",
    fill: "#a3d4f7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunshine);
export default __webpack_public_path__ + "static/media/sunshine.4e5711a29e5525c18faa2ee80a617a28.svg";
export { ForwardRef as ReactComponent };